import type { User, UserStatus } from '@repo-level/core-front';
import type { TPrizeType } from 'api/cms/missions';
import type { BonusStage } from 'api/common';
import { groupMember } from 'helpers/user';
import {
  CASH_BONUS_MISSION_IDS,
  CP_MISSION_IDS,
  INACTIVE_BONUS_STAGES,
  MAX_PROGRESS,
  MISSION_PREFIX,
} from '../constants';
import type { MissionId } from '../types';
import { MissionRewardType, MissionStatus } from '../types';

export const isBonusInactive = (bonusStage?: BonusStage): boolean =>
  Boolean(bonusStage && INACTIVE_BONUS_STAGES.includes(bonusStage));

export const getMissionRewardType = (
  backendId?: string,
  prizeType?: TPrizeType
): MissionRewardType => {
  if (backendId && CP_MISSION_IDS.includes(backendId as MissionId)) {
    return MissionRewardType.CP;
  }
  if (backendId && CASH_BONUS_MISSION_IDS.includes(backendId as MissionId)) {
    return MissionRewardType.CASH_BONUS;
  }
  if (prizeType === 'fs') {
    return MissionRewardType.FREE_SPINS;
  }
  if (prizeType === 'cp') {
    return MissionRewardType.CP;
  }
  return MissionRewardType.FREE_SPINS;
};

export const isCompletedByGroup = (
  backendId: string | undefined,
  user: User | undefined
): boolean => Boolean(backendId && user && groupMember(backendId)(user));

export const getIsMissionDone = (
  backendId: string | undefined,
  user: User | undefined,
  progress: number
): boolean => {
  if (isCompletedByGroup(backendId, user)) return true;
  return progress >= MAX_PROGRESS;
};

export const getMissionStatus = (
  isMissionDone: boolean,
  progress: number
): MissionStatus => {
  if (isMissionDone) return MissionStatus.DONE;
  if (progress > 0) return MissionStatus.ACTIVE;
  return MissionStatus.DEFAULT;
};

export const getMissionIdsFromStatuses = (statuses: UserStatus[]): string[] =>
  statuses.filter((s) => s.id.startsWith(MISSION_PREFIX)).map((s) => s.id);

export const canAssignMission = (
  user: User | undefined,
  isShowQuests: boolean,
  missionId: MissionId
): boolean =>
  !!user &&
  isShowQuests &&
  !getMissionIdsFromStatuses(user.statuses).includes(missionId);
